import { render, staticRenderFns } from "./EmployerData.vue?vue&type=template&id=ef3d2fba&"
import script from "./EmployerData.vue?vue&type=script&lang=js&"
export * from "./EmployerData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports